import { Link, Navigate, useParams } from "react-router-dom";
import { Button } from "../components/ui/button";

const STYLES = {
    minimal: {
        key: "minimal",
        name: "Ultra Premium Minimal",
        badge: "A",
        bg: "bg-[#0C0C0D]",
        panel: "bg-[#121214] border-white/10",
        heading: "text-[#F3F3F4]",
        accent: "#B9A16B",
        gradient: "from-[#1A1A1B] to-[#101012]",
        subtitle:
            "Daha sakin, daha net ve yüksek güven veren premium kurumsal görünüm.",
    },
    editorial: {
        key: "editorial",
        name: "Cesur Editorial",
        badge: "B",
        bg: "bg-[#0E090E]",
        panel: "bg-[#1A0E18] border-[#5B2448]/40",
        heading: "text-[#FFE8F2]",
        accent: "#FF4D6D",
        gradient: "from-[#351227] to-[#130A13]",
        subtitle:
            "Daha iddialı tipografi, daha güçlü marka karakteri, daha çarpıcı ilk izlenim.",
    },
    fintech: {
        key: "fintech",
        name: "Fintech Luxury",
        badge: "C",
        bg: "bg-[#09111A]",
        panel: "bg-[#102030] border-[#2C5E86]/40",
        heading: "text-[#E6F5FF]",
        accent: "#35D0FF",
        gradient: "from-[#122B42] to-[#0B1520]",
        subtitle:
            "Güven + satış dengesini güçlü veren kurumsal premium finans dili.",
    },
};

export default function DesignHomepagePreviewPage() {
    const { style } = useParams();
    const s = STYLES[style];

    if (!s) return <Navigate to="/design-preview" replace />;

    return (
        <main
            data-testid={`design-homepage-preview-${s.key}`}
            className={`min-h-screen ${s.bg} text-white`}
        >
            <header
                data-testid="design-preview-header"
                className="border-b border-white/10 bg-black/20"
            >
                <div className="max-w-6xl mx-auto px-6 py-4 flex items-center justify-between">
                    <p className="font-display font-bold text-xl tracking-tight">Adrise</p>
                    <div className="flex gap-2">
                        <Link to="/design-preview" data-testid="design-preview-back-link">
                            <Button
                                variant="outline"
                                className="border-white/15 bg-white/[0.02]"
                            >
                                Stile dön
                            </Button>
                        </Link>
                        <Button
                            data-testid="design-preview-primary-cta"
                            className="text-black"
                            style={{ backgroundColor: s.accent }}
                        >
                            Apply for access
                        </Button>
                    </div>
                </div>
            </header>

            <section data-testid="design-preview-hero" className="px-6 pt-16 pb-10">
                <div className="max-w-6xl mx-auto grid lg:grid-cols-12 gap-8 items-center">
                    <div className="lg:col-span-7">
                        <p className="text-xs uppercase tracking-[0.28em] text-white/60 mb-4">
                            Style {s.badge} · {s.name}
                        </p>
                        <h1
                            className={`font-display font-black text-4xl sm:text-5xl lg:text-6xl leading-[1.05] ${s.heading}`}
                            data-testid="design-preview-hero-title"
                        >
                            Agency ad operations,
                            <br />
                            redesigned for trust.
                        </h1>
                        <p
                            className="mt-5 text-sm md:text-base text-white/75 max-w-2xl"
                            data-testid="design-preview-hero-subtitle"
                        >
                            {s.subtitle}
                        </p>
                    </div>

                    <div className="lg:col-span-5">
                        <div
                            data-testid="design-preview-hero-card"
                            className={`rounded-2xl border p-6 bg-gradient-to-br ${s.gradient} ${s.panel}`}
                        >
                            <p className="text-xs text-white/60">Monthly Performance Snapshot</p>
                            <div className="mt-4 grid grid-cols-2 gap-3">
                                <div className="rounded-xl border border-white/10 p-4 bg-black/15">
                                    <p className="text-xs text-white/60">Spend</p>
                                    <p className="text-2xl font-bold mt-1">$412k</p>
                                </div>
                                <div className="rounded-xl border border-white/10 p-4 bg-black/15">
                                    <p className="text-xs text-white/60">ROAS</p>
                                    <p className="text-2xl font-bold mt-1">3.8x</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section data-testid="design-preview-sections" className="px-6 pb-16">
                <div className="max-w-6xl mx-auto grid md:grid-cols-3 gap-4">
                    {[
                        "Compliance-first onboarding",
                        "Volume-based fee structure",
                        "Dedicated account operations",
                    ].map((item, idx) => (
                        <article
                            key={item}
                            data-testid={`design-preview-feature-${idx + 1}`}
                            className={`rounded-2xl border p-5 ${s.panel}`}
                        >
                            <div
                                className="w-7 h-7 rounded-md mb-3"
                                style={{ backgroundColor: s.accent }}
                            />
                            <p className="text-sm font-medium text-white/90">{item}</p>
                            <p className="text-xs text-white/60 mt-2">
                                Bu blok, seçilen stile göre kart yapısı ve tipografi ritmini gösterir.
                            </p>
                        </article>
                    ))}
                </div>
            </section>
        </main>
    );
}
